export enum Theme {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertary = 'tertary',
  Link = 'link',
  Quaternary = 'quaternary'
}
